import { EventsDTO } from '../models/events.modal';

export function hasCompleteWebinarRoomDetails(
  event: EventsDTO | null | undefined
): boolean {
  return [
    event?.roomId,
    event?.webinarId,
    event?.streamId,
    event?.webinarPasscode,
  ].every((value) => typeof value === 'string' && value.trim().length > 0);
}

/**
 * The authenticated host projection intentionally omits the provider passcode.
 * Starting the host chat room needs the provider identifiers, while the API
 * remains the authority that rejects an event whose stored provider state is
 * not ready. Do not use this check to issue an attendee Watch handoff.
 */
export function hasCompleteHostWebinarRoomDetails(
  event: EventsDTO | null | undefined
): boolean {
  return [event?.roomId, event?.webinarId, event?.streamId].every(
    (value) => typeof value === 'string' && value.trim().length > 0
  );
}

export function getWebinarStatusError(
  error: any,
  fallback = 'Unable to update the webinar status. Please try again.'
): string {
  const message = error?.message || error?.error?.message;
  return typeof message === 'string' && message.trim().length > 0
    ? message
    : fallback;
}
